import axios from 'axios';
import { API_BASE_URL } from 'utils/api';
import { useAuthStore } from 'stores/auth-store';

export const http = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

http.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;

  if (token) {
    config.headers.Authorization = token;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401 && typeof window !== 'undefined') {
      useAuthStore.getState().clearSession();

      if (!window.location.pathname.startsWith('/login')) {
        const path = `${window.location.pathname}${window.location.search}`;
        window.location.assign(`/login?redirect=${encodeURIComponent(path)}`);
      }
    }

    return Promise.reject(error);
  },
);
